import { GtxPageWithoutStore } from 'gtx-react/components/GtxApp/GtxApp';
import { PreRedirectPageView } from '../views/PreRedirectPageView';

export const preRedirectPage: GtxPageWithoutStore = {
    header: false,
    container: () => <PreRedirectPageView />,
    path: '/signin',
};
